import axios from 'axios'
import config from './config'

import { setSignedIn, setSignedOut } from './actions/authenticate'
import { setUser, unsetUser } from './actions/user'
import { setLogin, setConsent } from './actions/layout'

const handleSignedIn = (dispatch, response) => {
  if (response.data.data.email) {
    dispatch(setUser(response.data.data))
    dispatch(setSignedIn())
    dispatch(setConsent())
  } else {
    logOut()
  }
}

export const checkIfLoggedIn = ({store, dispatch}) => {
  const dp = dispatch || store.dispatch;
  const myStorage = window.localStorage
  if (myStorage.getItem('token')) {
    axios.defaults.headers.common['authorization'] = myStorage.getItem('token')
    axios.get(`${config.apiUrl}/authenticate`)
      .then(function (response) {
        response.data.success ? handleSignedIn(dp, response) : logOut(dp)
      })
      .catch(function (error) {
        logOut(dp)
      })
  } else {
    logOut(dp);
  }
}

export const logOut = (dispatch) => {
  const myStorage = window.localStorage
  delete axios.defaults.headers.common['authorization']
  myStorage.removeItem('token')
  dispatch(unsetUser())
  dispatch(setSignedOut())
  dispatch(setLogin())
}


// WEBPACK FOOTER //
// ./src/auth.js